export const Colors = {
  primary: '#0d6efd',
  secondary: '#adb5bd',
  white: 'white',
  black: 'black',
  grey: '#cccccc',
};
